import ContactsModal from "../../components/ContactsModal/ContactsModal";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { useSiteData } from "../../contexts/SiteDataContext";

function ProtocolPage() {
  const { siteData } = useSiteData();

  return (
    <div className="bg-main">
      <Header />

      <section className="w-full text-dark-2">
        <div className="2xl:px-0 px-3 mx-auto pt-12 pb-16 md:pt-[4.5rem] md:pb-[7.5rem] max-w-[47.5rem] w-full">
          <h2 className="text-[1.5rem] md:text-[2rem] font-bold leading-[120%] tracking-[0.01em] mb-6 text-left md:text-center">
            {siteData?.protocol?.title}
          </h2>

          <div
            dangerouslySetInnerHTML={{
              __html: siteData?.protocol?.content ?? "",
            }}
            className="prose prose-lg max-w-none"
          />
        </div>
      </section>

      <Footer />
      <ContactsModal />
    </div>
  );
}

export default ProtocolPage;
